export class ScheduleOptionsCache {
    public showHolidays: boolean;
    public showEvents: boolean;
    public showExams: boolean;
}